<template>
    <div>
      <h1>编辑案例信息</h1>
      <el-form :model="caseInfo" v-loading="caseInfo.loading" ref="caseForm">
        <el-form-item label="案例名称">
          <el-input v-model="caseInfo.name" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="案例作者">
          <el-input v-model="caseInfo.author" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="案例企业名称">
          <el-input v-model="caseInfo.company" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="案例企业所属行业及规模">
          <el-input v-model="caseInfo.industry" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="适用课程">
          <el-input v-model="caseInfo.course" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="案例知识点">
          <el-input v-model="caseInfo.knowledgePoints" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="附件上传 （.pdf / .doc / .docx）">
                                <el-upload
                                    :action="uploadsFile"
                                    :file-list="fileList"
                                    :on-success="uploadFileSuccess"
                                    :on-error="uploadFileError"
                                    :before-upload="beforeUpload"
                                >
                                    <el-button size="small" type="primary">
                                        点击上传
                                    </el-button>
                                </el-upload>
                            </el-form-item>
        <el-form-item>
            <el-button type="info" @click="cancelEditor">返回</el-button>
          <el-button type="primary" @click="saveCase">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </template>



<script>
import CaseEditor from "@/assets/js/manager/CaseEditor.js";
export default {
    ...CaseEditor
};
</script>